<template>
    <div>
        <!--四个图片-->
        <div class="item" v-if="urls.length>=4">
            <div class="font" style="-webkit-box-orient: vertical;text-overflow: ellipsis;overflow: hidden;word-break: break-all;display: -webkit-box;-webkit-line-clamp: 2;">
                {{content}}
            </div>
            <div class="imgsFour">
                <div v-for="(item,index) in urls" v-if="index<4">
                    <img :src="item.small_path_url" />
                </div>
            </div>
        </div>
        <!--三个图片-->
        <div class="item" v-if="urls.length==3">
            <div class="font" style="-webkit-box-orient: vertical;text-overflow: ellipsis;overflow: hidden;word-break: break-all;display: -webkit-box;-webkit-line-clamp: 2;">
                {{content}}
            </div>
            <div class="imgsThree">
                <div v-for="(item,index) in urls" v-if="index==0">
                    <img class="caijian" :src="item.small_path_url" />
                </div>
                <div >
                    <div class="ThreeItem" v-for="(item,index) in urls" v-if="index>0">
                        <img :src="item.small_path_url" />
                    </div>
                </div>
            </div>
        </div>
        <!--两个图片-->
        <div class="item" v-if="urls.length==2">
            <div class="font" style="-webkit-box-orient: vertical;text-overflow: ellipsis;overflow: hidden;word-break: break-all;display: -webkit-box;-webkit-line-clamp: 2;">
                {{content}}
            </div>
            <div class="imgsTwo">
                <div v-for="(item,index) in urls" >
                    <img class="caijian" :src="item.small_path_url" />
                </div>
            </div>
        </div>
        <!--一个图片-->
        <div class="item" v-if="urls.length==1">
            <div class="font" style="-webkit-box-orient: vertical;text-overflow: ellipsis;overflow: hidden;word-break: break-all;display: -webkit-box;-webkit-line-clamp: 2;">
                {{content}}
            </div>
            <div class="imgsOne">
                <div v-for="(item,index) in urls" >
                    <img :src="item.small_path_url" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
let me;
export default {
    name:"goodsTemplate",
    data(){
        return{

        }
    },
    props:{
        urls:{
            type:Array,
            default:()=>{}
        },
        content:{
            type:String,
            default:""
        }
    },
    methods: {
        
    },
    mounted() {
        me=this;
    }
}
</script>
<style scoped>
.caijian{
    object-fit:cover
}
.item{
    width:121px;
    height:152.5px;
    background-color:#fff;
    margin-left:10px;
    margin-bottom:7px;
    padding:4px 3px 5px 3px;
}
.font{
    width:107px;
    margin-left:6.5px;
    font-size:10px;
    color:#666666;
    white-space: unset;
    overflow: hidden;
    text-overflow: ellipsis;
}
.imgsFour{
    display:flex;
    flex-wrap:wrap;
    margin-top:7px;
}
.imgsFour img{
    width:100%;
    height:100%;
}
.imgsFour>div{
    width:57.5px;
    height:57.5px;
    margin-top:2px;
    margin-left:2px;
}
.imgsThree,.imgsTwo{
    display:flex;
}
.imgsThree>div{
    width:57.5px;
    margin-top:4px;
    margin-left:2px;
}
.imgsTwo>div{
    height:117px;
    padding-top:2px;
    width:57.5px;
    margin-top:4px;
    margin-left:2px;
}
.imgsThree>div:nth-child(1){
    height:117px;
    padding-top:2px;
}
.ThreeItem{
    width:57.5px;
    height:57.5px;
    padding-top:2px;
}
.ThreeItem img{
    width:100%;
    height:100%;
}
.imgsOne>div{
    margin-top:8px;
    width:115px;
    height:115px;
}
.imgsOne img{
    width:100%;
    height:100%;
}
</style>